import React, { createContext, useState } from "react";

interface NavbarContextType {
  isNavbarOpen: boolean;
  toggleNavbar: () => void;
  openNavbar: () => void;
  closeNavbar: () => void;
}

export const NavbarContext = createContext<NavbarContextType>(null!);

interface Props {
  children: React.ReactNode;
}

const NavbarProvider: React.FC<Props> = ({ children }) => {
  const [isNavbarOpen, setIsNavbarOpen] = useState(true);

  const toggleNavbar = () => {
    setIsNavbarOpen((prev) => !prev);
  };

  const openNavbar = () => {
    setIsNavbarOpen(true);
  };

  const closeNavbar = () => {
    setIsNavbarOpen(false);
  };

  return (
    <NavbarContext.Provider
      value={{
        isNavbarOpen,
        toggleNavbar,
        openNavbar,
        closeNavbar,
      }}
    >
      {children}
    </NavbarContext.Provider>
  );
};

export default NavbarProvider;
